import ArrowSvg from '@img/icons/arrow-right.svg';
import * as React from 'react';
import S from './PageContentsList.styles';
const PageContentsList = ({ title, listTitle, items, theme }) => {
    return (React.createElement(S.Container, { "data-theme": theme },
        React.createElement(S.Inner, null,
            React.createElement(S.Title, null, title),
            listTitle && React.createElement(S.ListLabel, null, listTitle),
            React.createElement(S.LinkList, null, items.map((item) => (React.createElement("li", { key: `pcl-${item.id ?? item.text}` },
                React.createElement("a", { href: item.url, target: item.target },
                    React.createElement(ArrowSvg, null),
                    item.text))))))));
};
export default PageContentsList;
